var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreecube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.274,
    height: 56.196,
    viewBox: "0 0 50.274 56.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "d512776bbd823464640325b1e2ba6ddd",
    transform: "translate(-3.5 -2.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M52.447,16.522,28.108,30.6,3.77,16.522a5.855,5.855,0,0,1,2.07-2.1L25.151,3.274a6.021,6.021,0,0,1,5.915,0L50.377,14.423a5.868,5.868,0,0,1,2.07,2.1Z",
    transform: "translate(0.528 0)",
    fill: "#16ebc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M28.637,21.317V49.411a6.181,6.181,0,0,1-2.691-.621L6.457,37.523A5.923,5.923,0,0,1,3.5,32.406V10.227A6.092,6.092,0,0,1,4.3,7.24Z",
    transform: "translate(0 9.282)",
    fill: "#1042f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M37.137,10.227v22.18a5.923,5.923,0,0,1-2.957,5.116L14.6,48.819a6.19,6.19,0,0,1-2.6.591V21.317L36.338,7.24A6.118,6.118,0,0,1,37.137,10.227Z",
    transform: "translate(16.637 9.282)",
    fill: "#af49ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreecube);
export default __webpack_public_path__ + "static/media/threecube.0ae2ce8e796d02845ff650fb755fb3c7.svg";
export { ForwardRef as ReactComponent };